<div class="sdps-text-l-body security-container">
    <div class="security-main sdps-m-left_xx-large">
        <div class="security-title">
          <span [innerHTML]="emtrConstant.rulesConstant.appliesTo"></span>
          <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
        </div>
        <div class="security-type">
            <div class="sdps-p-right_x-large">
                <p-checkbox inputId="appliesToIndividualSecurities" class="emtr-checkbox" [value]=""
                    [(ngModel)]="appliesType['individualSecurities']" binary="true" (ngModelChange)="updateAppliesTo()" />
                <label class="sdps-p-left_x-small" for="appliesToIndividualSecurities">Individual Securities</label>
            </div>
            <div>
                <p-checkbox inputId="appliesToUnderlyingOptions" class="emtr-checkbox" [(ngModel)]="appliesType['underlyingOptions']"
                    binary="true" (ngModelChange)="updateAppliesTo()" />
                <label class="sdps-p-left_x-small" for="appliesToUnderlyingOptions">{{(businessUnit === sharedConstant.rbsBUText || businessUnit === '') ? emtrConstant.rulesConstant.underlyingDerivatives : emtrConstant.rulesConstant.underlyingOptions}}</label>
            </div>
        </div>
    </div>
</div>
